<template>
    <div class="psycologist-card d-flex align-items-center">
        <img class="psycologist-card__profile-image" :src="imageUrl" alt="img_profile" v-if="!dummy">
        <template v-else>
            <img class="psycologist-card__profile-image" src="@/assets/psycologists/configurations/dani.png" alt="img_profile" v-if="dummyId == 1">
            <img class="psycologist-card__profile-image" src="@/assets/psycologists/configurations/gabi.png" alt="img_profile" v-if="dummyId == 2">
            <img class="psycologist-card__profile-image" src="@/assets/psycologists/configurations/moni.png" alt="img_profile" v-if="dummyId == 3">
        </template>
        <p class="psycologist-card__name ellipsis mb-2">{{ title }}</p>
        <p class="psycologist-card__profile ellipsis mb-2">{{t('appointments.schedule-appointment.psychologist-card-info.user-title')}}</p>
      <!-- <p class="text-info-sh">{{t('appointments.schedule-appointment.psychologist-card-info.user-title')}}</p> -->

        <p class="psycologist-card__experience ellipsis">{{ subtitle2 }}</p>
        <div class="psycologist-card__detail-buttons mb-3">
            <div style="display: inline-block;">
                <button type="button" class="btn mm-btn mm-btn-primary mm-btn-small text-uppercase me-2 audio-button"
                    @click="playAudio" v-if="audio">
                    <img :id="id" src="@/assets/icons/audio-yellow.svg" alt="icon">
                    {{ t('psycologists-options.watch-video')}}
                </button>

                <audio ref="audioPlayer" :src="audio"></audio>
            </div>

            <!-- <a href="#" @click.prevent="playAudio" class="btn btn-sherpa-strong-light-blue me-2 audio-button">
                <img src="@/assets/icons/audiob.svg" alt="">
                {{ t('psycologists-options.watch-video')}}
            </a> -->

            <a href="#" @click.prevent="goToProfileDetail" class="btn mm-btn mm-btn-primary mm-btn-small text-uppercase">{{ t('psycologists-options.see-more') }}</a>
        </div>
        <h3 class="psycologist-card__skills-title mb-3">{{ t('psycologists-options.skills-title') }}</h3>
        <div class="psycologist-card__skills-container mb-3">
            <span class="skill-badge" v-for="(skill, index) in skills" :key="index">{{ skill }}</span>
        </div>

        <p class="cost-title mb-2" v-if="!is100User">{{ t('psycologists-options.cost-per-session') }}</p>

        <div :style="{width: '100%'}" class="costs-container mb-3" v-if="!is100User">
            <p class="cost">{{ t('psycologists-options.single') }} <span>{{ '$ ' +individual_session_price }} + IVA</span></p>
            <!-- <p class="cost">{{ t('psycologists-options.couple') }} <span>{{ '$ ' +couple_session_price }}</span></p> -->
        </div>

        <button @click.prevent="selectPsychologits" class="btn mm-btn full-width mm-btn-secondary text-uppercase fs-16" style="color: var(--mm-medium-dark);">
            {{ t('select') }}
        </button>
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { computed, ref } from "vue";
import { useGtm } from '@gtm-support/vue-gtm';
import {useStore} from "vuex";

export default {
    props: {
        id: {
            default: "",
        },
        title: {
            default: "",
        },
        subtitle1: {
            default: "",
        },
        subtitle2: {
            default: "",
        },
        skills: {
            default: () => [],
        },
        individual_session_price: {
            default: "",
        },
        couple_session_price: {
            default: "",
        },
        imageUrl: {
            default: " ",
        },
        audio: {
            default: ""
        },
        dummy: {
            required: false,
            default: false
        },
        dummyId: {
            required: false,
            default: 0
        }
    },
    setup(props) {
        const { t } = useI18n()
        const gtm = useGtm();
        const router = useRouter()
        const store = useStore();
        const is100User = computed(() => store.getters['auth/is100User']);
        const audioPlayer = ref(null);
        const goToProfileDetail = () => {
            gtm.trackEvent({
                event: 'evFlowStep5',
                opcion: 'Ver más',
                name: props.title,
                costo: props.individual_session_price,
                especialidad: props.skills.join("|")
            });
            router.push({ name: 'psychologist-details', params: { id: btoa(props.id) } })
        }
        const selectPsychologits = () => {
            gtm.trackEvent({
                event: 'evFlowStep5',
                opcion: 'Seleccionar',
                name: props.title,
                costo: props.individual_session_price,
                especialidad: props.skills.join("|")
            });
            router.push({ name: 'schedule-appointment', params: { psychologiId: btoa(props.id)} });
        }

        const playAudio = () => {
            const playerIcon = document.getElementById(`${props.id}`)

            if (audioPlayer.value?.playing) {
                audioPlayer.value.pause()
                playerIcon.src = require('@/assets/icons/audiob.svg')
            } else {
                gtm.trackEvent({
                    event: 'evFlowStep5',
                    opcion: 'Audio',
                    name: props.title,
                    costo: props.individual_session_price,
                    especialidad: props.skills.join("|")
                });
                audioPlayer.value.play()
                playerIcon.src = require('@/assets/icons/pausewhite.svg')
            }

            audioPlayer.value.playing = !audioPlayer.value.playing
        }

        return {
            audioPlayer,
            is100User,
            t,
            goToProfileDetail,
            selectPsychologits,
            playAudio
        }
    }
}
</script>

<style>
.psycologist-card {
    width: 100%;
    max-width: 360px;
    min-height: 618px;
    background-color: var(--white);
    padding: 15px 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* box-shadow: 0px 0px 6px #00000029; */
    box-shadow: none !important;
    border-radius: 15px !important;
    margin: 0 auto;
}

.psycologist-card__profile-image {
    width: 115px;
    height: 115px;
    border-radius: 100px;
    margin: 0 auto 15px;
    object-fit: scale-down;
}

.psycologist-card__name {
    font-family: var(--mm-font-basier-circle);
    color: var(--mm-medium-dark);
    font-size: 20px;
    font-weight: 600;
    line-height: 1.2;
}

.psycologist-card__profile,
.psycologist-card__experience {
    font-family: var(--mm-font-gt-america-mono);
    font-size: 18px;
    color: var(--mm-surface-two);
    font-weight: 400;
    line-height: 1.2;
    text-transform: uppercase;
}

.mm-btn.mm-btn-small {
  --mm-btn-small-padding: 4px 6px;
  --mm-btn-small-radius: 8px;
  border-radius: var(--mm-btn-small-radius);
  padding: var(--mm-btn-small-padding);
  font-size: var(--mm-btn-small-font-size);
  display: inline-flex;
  align-items: center;
  font-weight: 400;
  gap: 4px;
}

.psycologist-card__detail-buttons .btn {
    font-size: 14px;
    padding: 4px 12px;
    border-radius: 10px;
}

.psycologist-card__detail-buttons .audio-button img {
    display: inline-block;
    width: 15px;
    height: auto;
    margin-right: 3px;
}

.psycologist-card__skills-title {
    font-family: var(--mm-font-basier-circle);
    font-size: 14px;
    font-weight: 400;
    color: var(--mm-primary);
}

.psycologist-card__skills-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    justify-content: center;
    height: auto;
    max-height: 150px;
    overflow-y: auto;
}

.skill-badge {
    font-family: var(--mm-font-gt-america-mono);
    font-size: 11px;
    font-weight: 400;
    text-transform: uppercase;
    line-height: 1;
    background-color: var(--mm-surface-one);
    padding: 4px 10px !important;
    border-radius: 100px;
    color: var(--mm-primary);
}

.costs-container {
    display: flex;
    /* justify-content: space-between; */
    justify-content: center;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(var(--mm-surface-two-rgb), 1);
}
.text-info-sh {
  color: #3D74AD !important;
  margin-bottom: 6px;
}
.cost-title {
    font-family: var(--mm-font-basier-circle);
    font-weight: 500;
    font-size: 18px;
    display: block;
    text-align: center;
    color: var(--mm-medium-dark);
}

.cost {
    display: inline-block;
    font-family: var(--mm-font-basier-circle);
    font-size: 17px;
    font-weight: 500;
    color: var(--mm-medium-dark);
    text-align: center;
    margin: 0;
}

.cost span {
    color: var(--mm-medium-dark);
}

.btn-sherpa-medium-dark-blue {
    display: block;
    width: 80%;
    margin: 0 auto;
    border-radius: 8px;
}
</style>
